module.exports = __webpack_public_path__ + "static/media/latin-america-political-economy-javier-santiso.d6cd8d5e.jpg";